'use es6';

import { Record } from 'immutable';
import PerRespondentTypeRecord from './PerRespondentTypeRecord';
import RatingLabelsRecord from './RatingLabelsRecord';
import ThankYouRecord from './ThankYouRecord';
const WebConfigBase = {
  backoff: undefined,
  backoffTimeUnit: undefined,
  calloutText: undefined,
  closeLabel: undefined,
  displayDelay: undefined,
  displayOnMobile: undefined,
  displayOnScroll: undefined,
  embedStyle: undefined,
  followUpQuestions: PerRespondentTypeRecord(),
  gdprLegalBasis: undefined,
  gdprSettings: undefined,
  language: undefined,
  portalId: undefined,
  question: undefined,
  submitLabel: undefined,
  surveyFrequency: undefined,
  surveyFrequencyBackoffInMinutes: undefined,
  surveyFrequencyType: undefined,
  surveyId: undefined,
  surveyType: undefined,
  thankYou: ThankYouRecord,
  themeColor: undefined
};
export const CsatWebSurveyConfigRecord = Record(Object.assign({}, WebConfigBase));
export const NpsWebSurveyConfigRecord = Record(Object.assign({}, WebConfigBase, {
  ratingLabels: RatingLabelsRecord,
  timeWhenContactCanBeSurveyedAgain: undefined
}));